import { httpClient } from '../http/httpClient'

export const removeTeam = async (id: string) => {
  const { data } = await httpClient.delete(`/team/${id}`)

  return data
}
